var _g, _use, _use2, _use3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientConnectUsageContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.59 6.943)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_fill",
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_stroke",
    width: "100%",
    height: "100%"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(12.59 13.143)",
    width: "100%",
    height: "100%"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(16.79 13.143)",
    width: "100%",
    height: "100%"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_fill",
    transform: "translate(20.59 13.143)",
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    d: "M0 2v10.4a2 2 0 0 0 2 2h10.41v5.3l5.299-5.3h2.11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_stroke",
    d: "M12.41 14.4h1v-1h-1zm0 5.3h-1v2.414l1.706-1.707zm5.299-5.3v-1h-.414l-.293.293zM1 12.4V2h-2v10.4zm1 1a1 1 0 0 1-1-1h-2a3 3 0 0 0 3 3zm10.41 0H2v2h10.41zm1 6.3v-5.3h-2v5.3zm3.592-6.007l-5.3 5.3 1.414 1.414 5.3-5.3zm2.816-.293H17.71v2h2.11zm1-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm0-10.4v10.4h2V2zm-1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zM2 1h17.818v-2H2zM1 2a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    d: "M2 1a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientConnectUsageContact);
export default __webpack_public_path__ + "static/media/ClientConnectUsage_contact.833743a24686ebc4cffa855345c6b949.svg";
export { ForwardRef as ReactComponent };